import React from 'react';
interface MockQRCodeProps {
  value: string;
  size?: number;
}
export function MockQRCode({
  value,
  size = 200
}: MockQRCodeProps) {
  // Simple deterministic hash function
  const simpleHash = (str: string): number => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return Math.abs(hash);
  };
  const hash = simpleHash(value);
  const gridSize = 21; // Standard QR code grid size
  const moduleSize = size / gridSize;
  // Generate deterministic pattern based on hash
  const generatePattern = (): boolean[][] => {
    const pattern: boolean[][] = [];
    let seed = hash;
    // Simple pseudo-random number generator
    const random = () => {
      seed = (seed * 9301 + 49297) % 233280;
      return seed / 233280;
    };
    for (let y = 0; y < gridSize; y++) {
      pattern[y] = [];
      for (let x = 0; x < gridSize; x++) {
        // Add finder patterns (corners)
        if (x < 7 && y < 7 ||
        // Top-left
        x >= gridSize - 7 && y < 7 ||
        // Top-right
        x < 7 && y >= gridSize - 7 // Bottom-left
        ) {
          // Finder pattern structure
          const isEdge = x === 0 || y === 0 || x === 6 || y === 6 || x === gridSize - 1 || y === gridSize - 1 || x === gridSize - 7;
          const isInner = (x === 2 || x === 3 || x === 4) && (y === 2 || y === 3 || y === 4);
          pattern[y][x] = isEdge || isInner;
        } else {
          // Random pattern for data area
          pattern[y][x] = random() > 0.5;
        }
      }
    }
    return pattern;
  };
  const pattern = generatePattern();
  return <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} xmlns="http://www.w3.org/2000/svg" className="border-4 border-gray-200 rounded-lg" data-id="element-83">
      {/* White background */}
      <rect width={size} height={size} fill="white" data-id="element-84" />

      {/* QR code modules */}
      {pattern.map((row, y) => row.map((isBlack, x) => isBlack ? <rect key={`${x}-${y}`} x={x * moduleSize} y={y * moduleSize} width={moduleSize} height={moduleSize} fill="black" data-id="element-85" /> : null))}
    </svg>;
}